import TimeUp from './TimeUp';

export default TimeUp;